import React from 'react';
import { Box, Container } from '@mui/material';
import MainHeader from './MainHeader';
import LiveNotifications from '../LiveNotifications';

export default function MainLayout({ children }) {
  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      minHeight: '100vh',
      background: `
        radial-gradient(circle at 20% 50%, rgba(102, 126, 234, 0.15) 0%, transparent 50%),
        radial-gradient(circle at 80% 80%, rgba(116, 185, 255, 0.15) 0%, transparent 50%),
        radial-gradient(circle at 40% 20%, rgba(255, 234, 167, 0.12) 0%, transparent 50%),
        linear-gradient(135deg, #e3f2fd 0%, #f3e5f5 50%, #fff3e0 100%)
      `
    }}>
      <MainHeader />
      {/* Global live notifications pop-ups */}
      <LiveNotifications />
      <Container
        component="main"
        maxWidth="xl"
        sx={{
          flexGrow: 1,
          py: { xs: 2, md: 4 },
          px: { xs: 1.5, sm: 2, md: 3 },
          width: '100%',
          overflowX: 'hidden',
        }}
      >
        {children}
      </Container>
    </Box>
  );
}